import { cva } from 'class-variance-authority';

export const itemVariant = {
  default:
    'text-primary [&_svg]:text-neutral-muted-foreground [&:hover_svg]:text-primary-hover [&[data-highlighted]_svg]:text-primary-hover hover:bg-neutral-muted data-[highlighted]:bg-neutral-muted',
  destructive:
    'text-destructive hover:text-destructive-hover hover:bg-destructive-minimal data-[highlighted]:bg-destructive-minimal',
};

export const dropdownMenuContentVariants = cva(
  [
    // TODO: Remove !important usages here once atomic-ui migration is complete
    // `!border`/`!border-solid`/`!border-neutral-muted` use Tailwind's important modifier
    // to survive Cloudscape's global `[role="menu"] { border: 0 none !important }`
    // reset (Base UI sets role="menu" on the popup). The scoped `.atomic-ui.\!border`
    // selector outspecifies `[role="menu"]`, so border width/style/colour all paint
    // while the two design systems still coexist during migration.
    'bg-neutral !border !border-solid !border-neutral-muted rounded-lg p-[5px] shadow min-w-[220px] overflow-hidden',
    // Animation classes
    'origin-[var(--transform-origin)] max-h-[var(--available-height)] overflow-y-auto transition-[opacity,transform] duration-150 ease-out data-[starting-style]:opacity-0 data-[starting-style]:scale-95 data-[ending-style]:opacity-0 data-[ending-style]:scale-95',
  ].join(' ')
);

export const dropdownMenuItemVariants = cva(
  'flex items-center gap-2 rounded-md px-2 py-1.5 text-lg outline-none select-none cursor-pointer data-[disabled]:pointer-events-none data-[disabled]:text-neutral-muted-foreground data-[disabled]:cursor-default [&_svg]:pointer-events-none [&_svg]:shrink-0',
  {
    variants: {
      variant: itemVariant,
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export const dropdownMenuSeparatorVariants = cva(
  'bg-neutral-muted -mx-px my-[3px] h-px'
);

export const dropdownMenuLabelVariants = cva(
  'text-neutral-muted-foreground px-2 py-1.5 text-sm font-semibold'
);
